angular.module("acl.common.dataRequester", ["acl.common.event"]);
